import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import RecentTransacTable from './RecentTransacTable';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 400,
    minHeight: 250,
    marginTop: '1.5rem'
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  title: {
    maxWidth: '200px',
    fontSize: 17,
    fontFamily: 'PT Serif',
    color: '#001E41',
    fontWeight: 'bold'
  },
  dropDown: {
    textAlign: 'right',
    marginTop: 10,
    fontFamily: 'PT sans',
    fontWeight: 'bold',
    fontSize: 14,
    color: '#252525'
  },
  details: {
    fontFamily: 'PT sans',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#002380',
    cursor: 'pointer'
  },
  data: {
    marginTop: '1.5rem',
    textAlign: 'center'
  }
}));

const Recent = () => {
  const classes = useStyles();

  return (
    <Card className={classes.root} elevation={0}>
      <CardContent>
        <div className={classes.container}>
          <Typography className={classes.title} gutterBottom>
            Recent comparable transactions
          </Typography>
          <Typography className={classes.details} gutterBottom>
            See details
          </Typography>
        </div>

        <RecentTransacTable />
        <hr
          style={{
            width: '100%',
            margin: '1rem auto',
            color: '#D8D8D8',
            opacity: '0.3'
          }}
        />
      </CardContent>
    </Card>
  );
};

export default Recent;
